import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import treatment_type from 'assets/branch/setting/TREATMENT_TYPE.png'
import treatment_tx from 'assets/branch/setting/TREATMENT_TX.png'
import { TREATMENT } from '../form-branch'

const OpTreatment = () => {
    const { t } = useTranslation()
    const optionTreatment = [
        {
            name: t('BRANCH.INPUT.APPT_SERVICE_TYPE'), value: TREATMENT.TYPE,
            component: <Treatment showType='TYPE' />,
        },
        {
            name: t('BRANCH.INPUT.APPT_SERVICE_TX'), value: TREATMENT.TX,
            component: <Treatment showType='TX' />,
        }
    ]
    return (optionTreatment)
}

export default OpTreatment

interface TreatmentProps {
    showType: 'TYPE' | 'TX'
}
const Treatment = (props: TreatmentProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={showType === 'TYPE' ? '0px' : '16px'}>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom={showType === 'TYPE' ? '0px' : '8px'}>
                    {t('BRANCH.INPUT.APPT_SERVICE')}
                </Typography>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'} >
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={showType === 'TYPE' ? treatment_type : treatment_tx} alt="" />
                </Box>
            </Box>
            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.INPUT.APPT_SERVICE_${showType}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.INPUT.SUB_APPT_SERVICE_${showType}`)}
                </Typography>
            </Box>
        </Box>
    )
}